// extracted by mini-css-extract-plugin
export default {"container":"AzerbaijanHistory_container__O1UHB"};